var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgDefaultAvatarPatientCare = function SvgDefaultAvatarPatientCare(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 42,
    height: 41,
    viewBox: "0 0 42 41",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.236 27.85a.76.76 0 0 1-.765-.75c0-3.675-3.363-6.638-7.49-6.638-4.127 0-7.452 3-7.452 6.638a.76.76 0 0 1-.765.75.76.76 0 0 1-.764-.75c.038-4.463 4.051-8.1 9.02-8.1 4.967 0 8.98 3.637 8.98 8.1a.76.76 0 0 1-.764.75zM21.5 18a4.493 4.493 0 0 1-4.5-4.5c0-2.495 2.013-4.5 4.5-4.5s4.5 2.005 4.5 4.5-2.013 4.5-4.5 4.5zm0-7.405c-1.618 0-2.96 1.31-2.96 2.905 0 1.595 1.342 2.905 2.96 2.905 1.618 0 2.96-1.31 2.96-2.905 0-1.595-1.342-2.905-2.96-2.905z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.643 28.24a.645.645 0 0 1-.643-.644v-3.953c0-.354.29-.643.643-.643.353 0 .643.29.643.643v3.953c-.032.354-.322.643-.643.643z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.66 26.286h-4.017a.645.645 0 0 1-.643-.643c0-.354.29-.643.643-.643h4.05c.353 0 .643.29.643.643 0 .353-.322.643-.675.643z"
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgDefaultAvatarPatientCare);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/default-avatar--patientCare.a69e8c08edee2dd3cfe572fc2fdd0989.svg";